export const DebugFlag = {
    mapNoState: window.location.href.includes('no-state'),
    mapNoImages: window.location.href.includes('no-images'),
    mapNoDocs: window.location.href.includes('no-docs')
}

Object.entries(DebugFlag).forEach(([key, val]) => {
    console.log(key, val);
})
